import type { FaireProductEntity } from "../../entity_types/product";

export const p_vs945k3rqd: FaireProductEntity = {
  token: "p_vs945k3rqd",
  type: "product",
  name: "Mama Two Tone Canvas Cotton Cap",
  brandToken: "b_2ig5ozgc",
  brandName: "Vanilla Monkey",
  imageUrl:
    "https://cdn.faire.com/fastly/f2ff80da1e1a029e6547b0ce723019afe9e448ba0712fd2c95dcf9fa11bdab47.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/57ea04cb4e614aa346ec4ad2ac85a92f27f96299a8777746d505fa9bbe7fb878.jpeg",
    "https://cdn.faire.com/fastly/7d7182f8ad7ce954072dd0fe694906b4e5b6c55b0fef389b3cfc460355fe1d86.jpeg",
    "https://cdn.faire.com/fastly/4d6974c9e7c400b9897ea59f3301c3edb4007c12ba14679ff28078e1c65e35a7.jpeg",
    "https://cdn.faire.com/fastly/c2b18665781ee5cfe9ed893273dfcb5254b4d87e86f0a9ee098cf8d3d9a96422.jpeg",
    "https://cdn.faire.com/fastly/457a2e2dc16a42f8a044a71dc6ed002a8786aa436a2bae3cfd92a190ecb37d51.jpeg",
    "https://cdn.faire.com/fastly/f7dc19cbf50900d72222df82741518068ec744917275866ef72febae52b2cfe9.jpeg",
    "https://cdn.faire.com/fastly/8e3d797acf5c1c3ed09a398b3979af6dc3ae77b807e1c150fcc0d9e8a181964c.jpeg",
    "https://cdn.faire.com/fastly/94fe82cc64b7d0a35df727790d305707ca10f3fe77eb339a8bd42a9fdc6a6877.jpeg",
    "https://cdn.faire.com/fastly/890beff358130327ec4942eee7378383500ac6e1df21ecfa6d149d9cd3ee3cfd.jpeg",
    "https://cdn.faire.com/fastly/cfd9bbfc7698bcdee9adc7ba21a3fe74d74c53b3489023ef84d567e5b214f2bb.jpeg",
    "https://cdn.faire.com/fastly/d6f1eac33f9512601064314902ba7480b037599d7c1f017786467af2da1a9c2c.jpeg",
    "https://cdn.faire.com/fastly/9a5b685b49141094060a25911d7a348a84fa15e1986df7b1200c7ec4df9c5e8d.jpeg",
  ],
  priceDollars: 6.25,
  description:
    '-"MAMA" TWO-TONE CANVAS\r\n-TRENDY DESIGN\r\n-ALL SEASONS\r\n-VERSATILE STYLE\r\n-ADJUSTABLE STRAP WITH METAL BUCKLE\r\n-LIGHTWEIGHT AND BREATHABLE MATERIAL\r\n-CIRCUMFERENCE: 22-25", BRIM: 2.35"\r\n\r\n*COLOR MAY VARY SLIGHTLY DUE TO MONITOR RESOLUTION*',
  tags: [],
  msrpDollars: 12.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:54:54.477Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
